import {Box, Button, CircularProgress, Grid, Typography} from "@mui/material";
import {instantBox, instantMainText, instantText, registrBox} from "./InstantPaymentsSignUp.sx";
import CustomInput from "app/components/CustomInput";
import {grayDefault} from "app/components/ThemeProvider/colors";
import InfoIcon from "app/components/Icons/InfoIcon";
import PhoneVerifyModal from "app/components/PhoneVerifyModal";
import React from "react";
import useInstantPaymentsSignUp from "./useInstantPaymentsSignUp";


const InstantPaymentsSignUp = () => {

    const {
        setInstantRegister,
        instantRegist,
        largeScreen,
        tabletScreen,
        smallScreen,
        dataHeaderAndMenu,
        phoneVerifyModal,
        isLoadingHeaderAndMenu,
        setPhoneVerifyModal,
        handleSubmit
    } = useInstantPaymentsSignUp();

    if (isLoadingHeaderAndMenu) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                    height: '100%',
                }}
            >
                <CircularProgress />
            </Box>
        );
    } else {

        return (
            !instantRegist ?
                <Box sx={instantBox}>
                    <Typography sx={instantMainText}>Ani ödənişlər sistemi</Typography>
                    <Typography sx={instantText}>Ani ödənişlər sistemi - vətəndaşların müxtəlif kredit təşkilatarında
                        hesabları
                        olsa belə, pul vəsaitlərini alıcının identifaktoru vasitəsilə köçürməsinə imkan verən sistemdir.
                        AÖS, dövlət ödənişləri də daxil olmaqla, mal və xidmətlər üçün 24/7 rejimdə ani ödənişlər etməyə
                        imkan
                        verir.</Typography>
                    <Button onClick={() => {
                        setInstantRegister(true)
                    }} sx={{marginTop: '8px'}}>Qeydiyyat</Button>
                </Box>
                :
                <>
                    <Box sx={registrBox}>
                        <Typography sx={{fontSize: '18px', fontWeight: 600}}>Şəxsi məlumatlar</Typography>
                        <Grid sx={{width: '668px', marginTop: '20px', flexDirection: tabletScreen ? 'column' : 'row'}}
                              container
                              rowSpacing="16px" columnSpacing={{xs: 0, sm: 0, md: 0}}>
                            {dataHeaderAndMenu?.user.company.inn.slice(-1) === '2' ?
                                <>
                                    <Grid item xs={largeScreen ? 5.6 : 6}>
                                        <CustomInput value={dataHeaderAndMenu?.user.company.title.split(" ")[0]}
                                                     width={largeScreen ? '295px' : '320px'} disabled={true}
                                                     title={'Ad'}
                                                     placeholder={'Ad'}/>
                                    </Grid>
                                    <Grid item xs={largeScreen ? 5.6 : 6}>
                                        <CustomInput value={dataHeaderAndMenu?.user.company.title.split(" ")[1]}
                                                     width={largeScreen ? '295px' : '320px'} disabled={true}
                                                     title={'Soyad'}
                                                     placeholder={'Soyad'}/>
                                    </Grid>
                                    <Grid item xs={largeScreen ? 5.6 : 6}>
                                        <CustomInput value={dataHeaderAndMenu?.user.company.title.split(" ")[2]}
                                                     width={largeScreen ? '295px' : '320px'} disabled={true}
                                                     title={'Ata adı'}
                                                     placeholder={'Ata adı'}/>
                                    </Grid>
                                </> :
                                <Grid item xs={largeScreen ? 5.6 : 6}>
                                    <CustomInput value={dataHeaderAndMenu?.user.company.title}
                                                 width={largeScreen ? '295px' : '320px'} disabled={true}
                                                 title={'Şirkətin adı'}
                                                 placeholder={'Şirkətin adı'}/>
                                </Grid>
                            }

                            <Grid item xs={largeScreen ? 5.6 : 6}>
                                <CustomInput value={dataHeaderAndMenu?.user.company.inn}
                                             width={largeScreen ? '295px' : '320px'}
                                             disabled={true} title={'VÖEN'} placeholder={'VÖEN'}/>
                            </Grid>
                        </Grid>
                        <Box sx={{marginTop: '40px', display: 'flex', gap: '32px', flexDirection: 'column'}}>
                            <Typography sx={{fontSize: '18px', fontWeight: 600}}>AÖS üçün əlaqə məlumatları</Typography>
                            <CustomInput value={dataHeaderAndMenu?.user.phone_plus}
                                         width={largeScreen ? '295px' : '320px'}
                                         disabled={true} title={'Mobil nömrə'} placeholder={'VÖEN'}/>
                            <Box sx={{
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                backgroundColor: grayDefault,
                                p: '10px 12px',
                                borderRadius: '6px',
                                width: 'fit-content'
                            }}>
                                <InfoIcon sx={{width: '16px', height: '16px'}}/>
                                <Typography sx={{fontSize: '14px'}}>Sorğu göndərilikdən sonra sizin telefona birdəfəlik
                                    sms şifrə
                                    göndəriləcək</Typography>
                            </Box>
                        </Box>
                        <PhoneVerifyModal open={phoneVerifyModal} close={setPhoneVerifyModal}
                                          value={dataHeaderAndMenu?.user.phone_plus}
                                          headerText={'Telefon nömrəsinin təsdiqi'}
                                          inputTitle={'Telefon nömrəsi'}
                                          handleSubmit={handleSubmit}/>
                    </Box>
                    <Box sx={{display: 'flex', gap: '8px', justifyContent: 'flex-end', minWidth: '335px'}}>
                        <Button size={smallScreen ? 'medium' : 'large'} color={'secondary'}>Geri qayıt</Button>
                        <Button onClick={() => {
                            setPhoneVerifyModal(true)
                        }} size={smallScreen ? 'medium' : 'large'} color={'info'} variant={'contained'}>Telefon
                            nömrəsini təsdiq
                            et</Button>
                    </Box>
                </>
        )
    }
}

export default InstantPaymentsSignUp;